<template>
  <div class="configurator-page-filter-group configurator-page-filter-group--grid">
    <h3 id="filter-group-categories">{{ pointStore.categories.heading }}</h3>
    <div
        aria-labelledby="filter-group-categories"
        class="configurator-page-filter-group__item"
        :class="[category.disabled ? 'configurator-page-filter-group__item--disabled' : 
        '', category.selected ? 'configurator-page-filter-group__item--selected' : '']"
        v-on:click="toggleCategory(category)"
        v-bind:key="category.Id"
        v-for="category in pointStore.categories.list">
      
      <span :class="category.iconClass"></span>
      <p>{{ category.name }}</p>
    </div>
  </div>

</template>

<script setup>
import {usePointStore} from '../store/store';


const pointStore = usePointStore();
const emit = defineEmits([
  'clicked',
  'toggleCategory'
]);

function toggleCategory(category) {
  emit('clicked', category);
  emit('toggleCategory', category);
}
</script>